import React from "react";
import petimg from "../../assets/images/pet.png";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import 'react-circular-progressbar/dist/styles.css';
import { useProfile } from "../../context/ProfileContext";

const Profile = (props) => {
  const percentage = props.completion;
  const { customerDetails } = useProfile();

  const getColor = (percentage) => {
    if (percentage < 45) {
      return "#FF0000"; // Red
    } else if (percentage < 100) {
      return "#FFD700"; // Yellow
    } else {
      return "#00FF00"; // Green
    }
  };

  return (
    <div className="p-4 bg-[#ECF7FF] rounded shadow-md flex flex-col items-center md:flex hidden">
      <div className="relative w-24 h-24">
        <CircularProgressbar
          value={percentage}
          styles={buildStyles({
            pathColor: getColor(percentage),
            trailColor: "#d6d6d6",
            strokeLinecap: "round",
          })}
          className="absolute top-0 left-0"
        />
        {/*<img
          src={petimg}
          alt="profile"
          className="w-20 h-20 rounded-full absolute top-2 left-2"
        />*/}
      </div>
      {customerDetails?.name && (
        <p className="text-center text-lg font-semibold mt-4 text-gray-800 capitalize">
          {customerDetails.name}
        </p>
      )}
      <p className="text-center text-sm mt-2 text-[#FF6216]">
        +91 {props.contact}
      </p>
      {props.completion<100?
      <p className="text-center text-sm mt-2">
    
        Complete your profile, it's at {props.completion}%
    
      </p>:"Your Profile is completed"
    }
    </div>
  );
};

export default Profile;
